/*
 * File: CustomNoteCard.tsx
 * Project: a-a
 * File Created: Wednesday, 9th April 2025 6:49:06 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 23rd July 2025 11:08:32 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Skeleton, Typography, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import zeplinColor from '../../../theme/Color';
import CustomPopOver from '../CustomPopOver/CustomPopOver';
import { Link } from 'react-router-dom';
import CustomButton from '../CustomButton/CustomButton';
import CustomModal from '../CustomModal/CustomModal';
import CustomCard from '../CustomCard/CustomCard';
import parse from 'html-react-parser';
import style from './CustomNoteCard.module.css';
const CustomNoteCard = ({
  data,
  setNotes,
  setEditId,
  editId,
  deleteNotes,
  loading,
  parse_sf,
  sfToken,
  task,
}: {
  data: any;
  setNotes: React.Dispatch<React.SetStateAction<string>>;
  editNotes: (title: string) => Promise<void>;
  setEditId: React.Dispatch<React.SetStateAction<string>>;
  editId: string;
  deleteNotes: (id: string) => Promise<void>;
  loading: boolean;
  sfToken: string;
  parse_sf: {
    access_token: string;
    id: string;
    instance_url: string;
    issued_at: string;
    refresh_token: string;
    scope: string;
    signature: string;
    token_type: string;
  };
  task: any;
}) => {
  const notesId = sessionStorage.getItem('notes_id') || '';
  const notesContent = sessionStorage.getItem('notes_content') || '';
  const [openModal, setOpenModal] = React.useState(false);
  const handleClose = () => {
    setOpenModal(false);

    sessionStorage.removeItem('sf_redirect');
    sessionStorage.removeItem('sf_edit_selected');
    sessionStorage.removeItem('notes_id');
    sessionStorage.removeItem('notes_content');
    sessionStorage.removeItem('sf_task_status');
  };
  const [anchorEl, setAnchorEl] = React.useState<HTMLImageElement | null>(null);
  const handleClick = (event: React.MouseEvent<HTMLImageElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const theme = useTheme();

  const [taskAnchorEl, setTaskAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const openTask = Boolean(taskAnchorEl);
  const idTask = openTask ? 'simple-popover' : undefined;

  const handleEditClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (sfToken === 'true') {
      setEditId(data?.id);
      setNotes(data?.content);
      setAnchorEl(null);
      setEditId(data?.id);
    } else {
      setTaskAnchorEl(e.currentTarget);
      sessionStorage.setItem('sf_redirect', 'Task');
      sessionStorage.setItem('sf_edit_selected', JSON.stringify(task));
      sessionStorage.setItem('notes_id', data?.id);
      sessionStorage.setItem('notes_content', data?.content);
      sessionStorage.setItem('sf_task_status', task?.status);
    }
  };
  const handleDeleteClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (sfToken === 'true') {
      // deleteNotes(data?.id);
      setOpenModal(true);
      setTaskAnchorEl(null);
      setAnchorEl(null);
    } else {
      setTaskAnchorEl(e.currentTarget);
    }
  };
  useEffect(() => {
    if (notesContent && sfToken === 'true') {
      setEditId(notesId);
      setNotes(notesContent);
      setAnchorEl(null);
    } else if (notesId && !notesContent) {
      data?.id === notesId && setOpenModal(true);
    }
  }, [notesId, notesContent]);
  // console.log(data?.id === notesId, notesId);
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '10px', xl: '16px' } }}>
      <Box
        sx={{
          display: 'flex',

          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '8px',
        }}
      >
        <Box
          sx={{
            display: 'flex',

            alignItems: 'center',

            gap: '8px',
          }}
        >
          <Box
            sx={{
              borderRadius: '100px',
              padding: '10px',
              width: { xs: '30px', xl: '36px' },
              height: { xs: '30px', xl: '36px' },
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: zeplinColor.Brand1,
            }}
          >
            {loading ? (
              <Skeleton variant='rounded' width={26} height={26} />
            ) : (
              <Typography variant='responsiveLabel1' color={zeplinColor.Neutral1}>
                {data?.title
                  ?.split(' ')
                  .map((value: any, index: number) =>
                    data?.title?.length &&
                    (index === 0 || index === data?.title.split(' ').length - 1)
                      ? value[0]
                      : '',
                  )}
              </Typography>
            )}
            {/* {profile?.profile_image_url ? (
              <img
                width={'36px'}
                height={'36px'}
                src={profile?.profile_image_url}
                alt='profile-img'
                style={{ borderRadius: '100px', objectFit: 'fill' }}
                // style={{}}
              />
            ) : (
              <Typography variant='label1' color={zeplinColor.Neutral1}>
                {'Aaron Eanes'
                  ?.split(' ')
                  .map((value: any, index: number) =>
                    'Aaron Eanes'?.length && (index === 0 || index === 'Aaron Eanes'.split(' ').length - 1)
                      ? value[0]
                      : '',
                  )}
              </Typography>
            )} */}
          </Box>
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                width: '1rem',
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography variant='responsiveBody2' color={zeplinColor.BasicBlack}>
              {data?.createdByName}
            </Typography>
          )}
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                width: '1rem',
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography variant='responsiveLabel1' color={zeplinColor.Neutral8}>
              {new Date(data?.createdDate)
                .toLocaleString('en-GB', {
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric',
                })
                .replace(/(\s)(\w{3})(\s)(\d{4})/, '$1$2, $4')}{' '}
              at{' '}
              {new Date(data?.createdDate).toLocaleString('en-GB', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
              })}
            </Typography>
          )}
        </Box>
        <img
          className={style['vertical-dots']}
          src={'/assets/vertical-dots.svg'}
          alt='options-icon'
          onClick={handleClick}
          aria-hidden='false'
          // style={{ imageRendering: 'pixelated', filter: 'blur(0px)' }}
        />
      </Box>
      {loading ? (
        <Skeleton
          variant='text'
          sx={{
            fontSize: theme.typography.body2,
            width: '100%',
            // Optionally adjust other styles here
          }}
        />
      ) : (
        <Typography
          variant='body3'
          color={zeplinColor.BasicBlack}
          sx={{
            whiteSpace: 'wrap',
            textWrap: 'wrap',
            flexWrap: 'wrap',
            wordWrap: 'break-word',
            width: '85%',
          }}
        >
          {/* Ensure all contract terms are reviewed and approved before proceeding. Follow up with the
        client for any pending documents or clarifications. */}
          {parse(data?.content)}
        </Typography>
      )}
      <CustomPopOver
        setAnchorEl={setAnchorEl}
        anchorEl={anchorEl}
        id={id}
        sx={{ borderRadius: '14px', boxShadow: 'rgba(0, 0, 0, 0.15)' }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '10px', xl: '16px' },
            padding: { xs: '10px', xl: '16px' },
          }}
        >
          <Box sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }} onClick={handleEditClick}>
            <img src={'/assets/edit.svg'} className={style['option-icon']} />
            <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
              Edit
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }} onClick={handleDeleteClick}>
            <img src={'/assets/delete-red.png'} className={style['option-icon']} />
            <Typography variant='responsiveBody3' color={zeplinColor.Error}>
              Delete
            </Typography>
          </Box>
        </Box>
      </CustomPopOver>
      <CustomPopOver
        setAnchorEl={setTaskAnchorEl}
        anchorEl={taskAnchorEl}
        id={idTask}
        sx={{
          borderRadius: '14px',
          boxShadow: 'rgba(0, 0, 0, 0.15)',
          marginTop: '8px',
          // marginRight: '2rem',
          // marginLeft: '-4rem',
        }}
      >
        <Box
          sx={{
            height: '202px',
            width: '340px',
            padding: '24px',
            display: 'flex',
            gap: '32px',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', gap: '12px', justifyContent: 'space-between' }}>
              <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                Authentication Required
              </Typography>
              <img
                src={'/assets/close-icon.svg'}
                width={24}
                height={24}
                alt='close'
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setTaskAnchorEl(null);
                  sessionStorage.removeItem('notes_id');
                  sessionStorage.removeItem('notes_content');
                }}
              />
            </Box>

            <Typography variant='body3' color={zeplinColor.BasicBlack}>
              {/* To create a new task, please ensure you're logged in to your Salesforce account. */}
              You need to be logged into Salesforce to perform this action. Please log in to your
              Salesforce account.
            </Typography>
          </Box>
          <Link
            // target='_blank'
            // rel='noopener noreferrer'
            to={`https://${process.env.REACT_APP_SALESFORCE_URI}/services/oauth2/authorize?client_id=3MVG9j6uMOMC1DNgaVQStO9P.Ry89BeJHH5h08FnGEGdr9ZupWzfpz.CZXWJz8uCdY._xCzlmq8iHiQo9EHQy&redirect_uri=${process.env.REACT_APP_REDIRECT}&response_type=code`}
          >
            <CustomButton
              disabled={false}
              onClick={() => {
                sessionStorage.setItem('sf_redirect', 'Task');
                sessionStorage.setItem('sf_edit_selected', JSON.stringify(task));
                sessionStorage.setItem('notes_id', data?.id);
                sessionStorage.setItem('sf_task_status', task?.status);
              }}
              variant='contained'
              color={'primary'}
              style={{
                width: '155px',
                borderRadius: '14px',
                height: '48px',
                padding: '14px 16px',
                '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
              }}
              textStyle={{ color: zeplinColor.Neutral1 }}
              text={'Open Salesforce'}
              // tabindex={4}
            />
          </Link>
        </Box>
      </CustomPopOver>
      <CustomModal handleClose={handleClose} open={openModal}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <CustomCard
            styles={{
              borderRadius: '14px',
              padding: '24px',
              backgroundColor: zeplinColor.Neutral1,

              width: '312px',
              height: '204px',
              boxShadow: 'rgba(0, 0, 0, 0.15)',
              // display: 'flex',
              // flexDirection: 'column',
              // justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
                // height: '100%',
                flex: 1,

                justifyContent: 'space-between',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                  flex: 1,
                }}
              >
                <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                  Delete Note?
                </Typography>
                <Typography variant='body2' color={zeplinColor.BasicBlack}>
                  Are you sure you want to delete this Note? This action cannot be undone
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  gap: '16px',
                  flex: 1,
                }}
              >
                <Box
                  onClick={handleClose}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: zeplinColor.Neutral1,
                      border: `1px solid ${zeplinColor.BasicBlack}`,
                      cursor: 'pointer',
                      // width: '312px',
                      // height: '183px',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                      // display: 'flex',
                      // flexDirection: 'column',
                      // justifyContent: 'space-between',
                    }}
                    aria-role='button'
                    aria-disable={loading}
                  >
                    <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                      Cancel
                    </Typography>
                  </CustomCard>
                </Box>
                <Box
                  onClick={() => {
                    deleteNotes(data?.id);
                    handleClose();
                  }}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: zeplinColor.Error,
                      cursor: 'pointer',
                      // border: `1px solid ${zeplinColor.BasicBlack}`,
                      // width: '312px',
                      // height: '183px',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                      // display: 'flex',
                      // flexDirection: 'column',
                      // justifyContent: 'space-between',
                    }}
                    aria-role='button'
                    aria-disable={loading}
                  >
                    <Typography
                      variant='buttonMedium'
                      color={zeplinColor.Neutral1}
                      sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                    >
                      {loading ? 'Deleting' : 'Delete'}
                    </Typography>
                  </CustomCard>
                </Box>
              </Box>
            </Box>
          </CustomCard>
          {/* {loading ? <CustomLoader /> : ''} */}
        </Box>
      </CustomModal>
    </Box>
  );
};

export default CustomNoteCard;
